<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon color="#fff" medium>alarm</v-icon>
          </div>
          <h1 style="display: inline">Horarios de colaboradores</h1>
        </v-flex>
      </v-layout>

      <template v-slot:extension v-if="permits['WATCH_SCHEDULE_COLLABORATOR']">
        <v-btn
          v-if="currentTab == 0 && permits['ADD_SCHEDULE_COLLABORATOR']"
          dark
          absolute
          bottom
          left
          fab
          color="gradiente"
          to="checker/create"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-speed-dial
          v-if="currentTab == 1"
          v-model="fab"
          key="1"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="gradiente" dark fab>
              <v-icon>more_vert</v-icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadPDF(filters)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar PDF</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadXLSX(filters)"
            >
              <v-img
                :style="{ flex: '0 1 auto' }"
                height="28px"
                width="28px"
                :src="require('@/assets/reports/IconoCSV.png')"
              />
            </v-btn>
            <span>Descargar XLSX</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadXlsModal"
            >
              <v-icon>sim_card_download</v-icon>
            </v-btn>
            <span>Exportar XLSX por fechas</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="showSettingModal"
            >
              <v-icon>settings</v-icon>
            </v-btn>
            <span>Ajuste de reportes</span>
          </v-tooltip>
        </v-speed-dial>
        <v-tabs
          v-model="currentTab"
          color="transparent"
          style="margin-left: 70px"
        >
          <v-tab v-for="tab in tabs" :key="tab.id">
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <div class="schedule-container">
      <v-tabs-items
        v-model="currentTab"
        v-if="permits['WATCH_SCHEDULE_COLLABORATOR']"
      >
        <v-tab-item :key="1">
          <Schedule :permits="permits" />
        </v-tab-item>
        <v-tab-item :key="2">
          <AttendanceTardies
            @configCollabsShedule="() => (currentTab = 0)"
            @updateFilters="
              (f) => {
                filters = f
              }
            "
          />
        </v-tab-item>
      </v-tabs-items>
      <div v-else>
        <v-layout>
          <v-flex xs12 sm10 md6 offset-sm1 offset-md3 mt-3>
            <v-card>
              <v-card-title class="justify-center">
                <h3 class="text-xs-center red--text text--darken-4">
                  No tienes permisos para acceder a esta sección
                </h3>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn flat color="primary" @click="$router.go(-1)"
                  >Regresar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <ReportSettings
      :show="showSetting"
      title="Configuración de horario de colaboradores"
      reportSettingtype="COLLABORATOR_ASSISTANCE"
      @closeEditSetting="onCloseEditSetting"
    />
    <loading v-model="toast.loading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación Exitosa"></success>
    <error v-model="toast.error" text="Ups ocurrió un error"></error>
    <DowloadXlsModal
      :isOpen="modalXls"
      :startDate="today"
      @onClose="modalXls = !modalXls"
      @onGetReport="downloadXlsReport"
      ref="dowloadXlsModalChecker"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import DowloadXlsModal from '../../Modals/DownloadXlsModal.vue'
import ReportSettings from '../../Modals/reportSettings.vue'
import AttendanceTardies from '../../Sections/Checker/AttendanceTardies.vue'
import Schedule from '../../Sections/Checker/Schedule.vue'

export default {
  components: {
    AttendanceTardies,
    Schedule,
    loading,
    success,
    error,
    DowloadXlsModal,
    ReportSettings,
  },
  data: () => ({
    showSetting: false,
    modalXls: false,
    today: moment().format('YYYY-MM-DD'),

    tabs: [
      { id: 1, name: 'Horario' },
      { id: 2, name: 'Asitencias y Retardos' },
    ],
    currentTab: 0,
    fab: false,
    filters: {},
    toast: {
      loading: false,
      success: false,
      error: false,
    },
    permits: [],
  }),
  methods: {
    onCloseEditSetting() {
      this.showSetting = false
    },
    showSettingModal() {
      this.showSetting = true
    },
    async mapPermits() {
      var usr = await this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs

      for (var c in catalogs) {
        if (catalogs[c].name.includes('SCHEDULE')) {
          this.permits[catalogs[c].name] = 1
        }
      }

      this.$forceUpdate()
    },
    downloadPDF(filters) {
      this.toast.loading = true
      const newFilters = {}
      for (const property in filters) {
        const value = filters[property]
        if (value) {
          newFilters[property] = value
        }
      }
      this.$store
        .dispatch('checker/downloadReportPDF', newFilters)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-horarios-colaboradores.pdf'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.toast.success = true
        })
        .catch((e) => {
          console.error(e)
          this.toast.error = true
        })
        .finally(() => (this.toast.loading = false))
    },
    downloadXLSX(filters, isModalXlsxDate = false, xlsxDates) {
      this.toast.loading = true
      let newFilters = {}
      for (const property in filters) {
        const value = filters[property]
        if (value) {
          newFilters[property] = value
        }
      }

      if (isModalXlsxDate === true) {
        newFilters = {
          ...newFilters,
          ...xlsxDates,
        }
      }

      this.$store
        .dispatch('checker/downloadReportXLSX', newFilters)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-horarios-colaboradores.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.toast.success = true
        })
        .catch((e) => {
          console.error(e)
          this.toast.error = true
        })
        .finally(() => (this.toast.loading = false))
    },
    downloadXlsModal() {
      this.$refs.dowloadXlsModalChecker.onOpen()
      this.modalXls = true
    },
    downloadXlsReport(e) {
      this.downloadXLSX(this.filters, true, {
        from: e.startDate,
        to: e.endDate,
      })
      this.$refs.dowloadXlsModalChecker.onClose()
      this.modalXls = false
    },
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
    }
  },
  watch: {
    getUser() {
      this.mapPermits()
    },
  },
  computed: {
    ...mapGetters(['getUser']),
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 194px);
}
</style>
